import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconButton = _resolveComponent("IconButton")!
  const _component_LoadWindow = _resolveComponent("LoadWindow")!
  const _component_ModalWindow = _resolveComponent("ModalWindow")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("nav", null, [
      _createVNode(_component_IconButton, {
        hint: _ctx.$t('save-characters-file'),
        type: "Save",
        variant: "transparent",
        onClick: _ctx.save
      }, null, 8, ["hint", "onClick"]),
      _createVNode(_component_IconButton, {
        hint: _ctx.$t('load-characters-file'),
        type: "Load",
        variant: "transparent",
        onClick: _ctx.openLoadModal
      }, null, 8, ["hint", "onClick"]),
      _createVNode(_component_IconButton, {
        hint: _ctx.$t('restore-character-sheet'),
        type: "Restore",
        variant: ['transparent', 'danger'],
        onClick: _ctx.clear
      }, null, 8, ["hint", "onClick"])
    ]),
    _createVNode(_component_ModalWindow, {
      modelValue: _ctx.modal,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.modal) = $event)),
      title: _ctx.$t('load-characters-file')
    }, {
      default: _withCtx(() => [
        _createVNode(_component_LoadWindow, {
          onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.modal = false))
        })
      ]),
      _: 1
    }, 8, ["modelValue", "title"])
  ], 64))
}